import { render, staticRenderFns } from "./disease_doctor.vue?vue&type=template&id=dfadd944&scoped=true&"
import script from "./disease_doctor.vue?vue&type=script&lang=js&"
export * from "./disease_doctor.vue?vue&type=script&lang=js&"
import style0 from "./disease_doctor.vue?vue&type=style&index=0&id=dfadd944&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfadd944",
  null
  
)

export default component.exports